// extracted by mini-css-extract-plugin
module.exports = {"container":"_25hk6BDYadSBQcDfUtVSmZ","title":"_2x_qN4HGTfEHhie7KgZ1ey","icon":"_3Z5JYII3yUOqwBzPAJPyNe","cardActions":"_3QiOKlMhvjqopIyAwysvkH"};